export const API_ROOT_URL = 'https://api.visceralapps.com'
export const API_URL = 'https://api.visceralapps.com/api'
export const APP_URL = 'https://vendor-portal.visceralapps.com/'
export const APP = 'consignment-portal'

export const PARAMS = {
	  'override': false,
	  'shop_url': 'visceral-apps-staging.myshopify.com',
	  'hash': 'alsdhuflIUhdlhaw1h2l3h1o23789qw8d'
}

export let PREFIX = '/apps/vendor-portal'



// WEBPACK FOOTER //
// ./src/localSettings.js